(() => {
  if (!customElements.get('collection-card-quantity')) {
    customElements.define('collection-card-quantity', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('click', (event) => {
        const quantity = event.target.closest('[data-quantity]');
        if (quantity) {
          const input = quantity.parentElement.querySelector('input');
          if (!input.value || !input.checkValidity()) input.value = input.min || '1';
          if (Number(quantity.dataset.quantity) > 0) input.stepUp(); else input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  if (customElements.get('collection-product-carousel')) return;
  customElements.define('collection-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.collection-carousel__track');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('click', (event) => {
        const arrow = event.target.closest('[data-direction]');
        if (arrow) {
          const card = this.track.querySelector('.collection-carousel__card');
          if (!card) return;
          this.track.scrollBy({ left: Number(arrow.dataset.direction) * (card.getBoundingClientRect().width + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      }, { signal });
      this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.buttons.forEach((button) => {
        button.hidden = max <= 2;
        button.disabled = Number(button.dataset.direction) < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max - 2;
      });
    }
    disconnectedCallback() { this.controller.abort(); this.observer.disconnect(); }
  });
})();
